import { render, staticRenderFns } from "./ComputedXp.vue?vue&type=template&id=d73fc9ca&scoped=true&"
import script from "./ComputedXp.vue?vue&type=script&lang=js&"
export * from "./ComputedXp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73fc9ca",
  null
  
)

export default component.exports